/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Partner_Connectors_Remove_ErrorInputs */



/**
* | output |
* | --- |
* | "Could not remove the connector package" |
*
* @param {Partner_Connectors_Remove_ErrorInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const partner_connectors_remove_error = /** @type {((inputs?: Partner_Connectors_Remove_ErrorInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partner_Connectors_Remove_ErrorInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Das Konnektor-Paket konnte nicht entfernt werden")
	return /** @type {LocalizedString} */ ("Could not remove the connector package")
});